import React from "react";
import Modal from "@/components/Common/Modals";
import LegalDocumentModal from "./LegalDocumentModal";
import { LEGAL_MODAL_CONFIG } from "../constants";
import { ModalState } from "../types";

interface LegalModalsProps {
  modalState: ModalState;
  toggleModal: (modalKey: keyof ModalState) => void;
  cancelIcon: string;
}

const LegalModals: React.FC<LegalModalsProps> = ({
  modalState,
  toggleModal,
  cancelIcon,
}) => {
  return (
    <>
      {LEGAL_MODAL_CONFIG.map(({ modalKey, documentType }) => (
        <Modal
          key={modalKey}
          isOpen={modalState[modalKey]}
          onCancel={() => toggleModal(modalKey)}
        >
          <LegalDocumentModal
            documentType={documentType}
            onCancel={() => toggleModal(modalKey)}
            cancelIcon={cancelIcon}
          />
        </Modal>
      ))}
    </>
  );
};

export default LegalModals;
